import axios from 'axios'
import { REACT_APP_PERITADOR_API } from 'cfgCommon/config'

export async function getCarLots() {
  const result = await axios.get(
    `${REACT_APP_PERITADOR_API}/takingCarManagment/carLots`,
  )
  return result?.data?.request || []
}
